import * as React from 'react';
import styled from 'styled-components';
import { Text, Card, Title } from 'components';

const YourPlanInfo = ({ monthlyPrice }: { monthlyPrice: number }) => (
    <StyledPlanInfoContainer>
      <Title level={4}>Your Plan</Title>
      <Card>
        <StyledCardContent>
          <StyledImage src="/img/BrokerBayLogo.png" alt="brokerbay-logo" />

          <StyledPlanInfo>
            <div>
              <Text block>Brokerage</Text>
              <Text block type="secondary">
                Front-desk Ecosystem
              </Text>
            </div>
            <Title level={2} data-cy="monthly-price">
              ${monthlyPrice}/mo*
            </Title>
          </StyledPlanInfo>
        </StyledCardContent>
      </Card>

      <StyledDisclaimer block type="secondary">
        * Your monthly price will update as you add or remove more chargeable
        users
      </StyledDisclaimer>
    </StyledPlanInfoContainer>
  );

export default YourPlanInfo;

const StyledPlanInfoContainer = styled.div`
  margin-bottom: 20px;
`;

const StyledPlanInfo = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-left: 20px;
`;

const StyledCardContent = styled.div`
  display: flex;
  align-items: center;
`;

const StyledImage = styled.img`
  width: 30px;
  max-width: 100%;
  max-height: 30px;
  margin-left: 5px;
`;

const StyledDisclaimer = styled(Text)`
  margin: 10px 0px;
  font-size: 12px;
`;
